export const GROUP_INFO_MEMBERS_COUNT = 'group-info-members-count';
